import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import { ChatbotProvider } from './contexts/chatbot-context';
import { PostHogProvider } from 'posthog-js/react';

// Fix for browser extensions (translation, Grammarly, etc.) that modify the DOM
// These extensions can cause React to crash when it tries to remove/modify nodes
// that have been moved by the extension. This patch handles those cases gracefully.
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function(child) {
    if (child.parentNode !== this) {
      if (console && console.warn) {
        console.warn('Cannot remove a child from a different parent', child, this);
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (console && console.warn) {
        console.warn('Cannot insert before a reference node from a different parent', referenceNode, this);
      }
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

// Import your publishable key
const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || process.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error('Missing Clerk Publishable Key. Please add VITE_CLERK_PUBLISHABLE_KEY to your .env.frontend file');
}

// Suppress benign ResizeObserver loop errors
// These errors don't affect functionality but can clutter the console
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
      e.message === 'ResizeObserver loop limit exceeded') {
    e.stopImmediatePropagation();
  }
});

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST;

const root = ReactDOM.createRoot(document.getElementById('root'));

const appTree = (
  <Router>
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      waitlistUrl="/waitlist"
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/upload"
      signUpFallbackRedirectUrl="/upload"
    >
      <ChatbotProvider>
        <App />
      </ChatbotProvider>
    </ClerkProvider>
  </Router>
);

root.render(
  <React.StrictMode>
    {POSTHOG_KEY ? (
      <PostHogProvider apiKey={POSTHOG_KEY} options={{ api_host: POSTHOG_HOST }}>
        {appTree}
      </PostHogProvider>
    ) : (
      appTree
    )}
  </React.StrictMode>
);

reportWebVitals();
